var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPath!=='/login' && _vm.currentPath!=='/register')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.BottomImg,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-title",staticStyle:{"color":"#888","font-size":"12px"},domProps:{"innerHTML":_vm._s(_vm.LoginBrowse)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c312a72e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 